/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { StructureGroup } from '../model/models';
import { StructureGroupLocation } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface StructureGroupServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Get All Structure Group Locations
     * Returns a list of all structure groups with their locations, external IDs, and names.
     */
    getAllStructureGroupLocationInformation(extraHttpRequestParams?: any): Observable<Array<StructureGroupLocation>>;

    /**
     * Get Structure Group Names with External IDs
     * Returns a list of structure group names with their external IDs from a projection.
     */
    getAllStructureGroupNamesWithExternalIds(extraHttpRequestParams?: any): Observable<Array<StructureGroup>>;

    /**
     * Get Paginated List of StructureGroupLocations
     * Returns a paginated list of structure groups represented by StructureGroupLocations.
     * @param numberOfItems Number of items to return per page
     * @param sortBy Sort the results by a specific field
     * @param offset Number of items to skip before starting to collect the result set
     */
    getPageStructureGroupList(numberOfItems: number, sortBy: string, offset: number, extraHttpRequestParams?: any): Observable<Array<StructureGroupLocation>>;

    /**
     * Get Structure Group by ID
     * Returns a structure group and its properties for a given ID.
     * @param structureGroupId ID of the structure group to return
     */
    getStructureGroupById(structureGroupId: number, extraHttpRequestParams?: any): Observable<StructureGroup>;

    /**
     * Get Count of StructureGroupLocations
     * Returns the count of elements of all StructureGroupLocations (currently not in use).
     */
    getStructureGroupLocationElements(extraHttpRequestParams?: any): Observable<number>;

    /**
     * Get Structure Group Location Information
     * Returns location, external ID, and name for a specific structure group ID.
     * @param structureGroupId ID of the structure group to return
     */
    getStructureGroupLocationInformationById(structureGroupId: number, extraHttpRequestParams?: any): Observable<StructureGroupLocation>;

    /**
     * Filter StructureGroupLocations
     * Returns a list of structure groups filtered by name and external ID represented by StructureGroupLocations.
     * @param structureGroupNameAndExternalId Search for StructureGroupName and ExternalId
     */
    getStructureGroupLocationsByIdAndName(structureGroupNameAndExternalId?: string, extraHttpRequestParams?: any): Observable<Array<StructureGroupLocation>>;

}
